import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(11, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(22, 0),
  },
  '& .TSHeader': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(10),
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  '& .TCSTourCardContainer': {
    '&:nth-child(5)': {
      [theme.breakpoints.down('xxl')]: {
        display: 'none',
      },
    },
  },
}));
export default StyledBox;
